import React from "react";
import {
  StatusCssClasses,
  StatusTitles
} from "../UIHelpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
export const CountrieslistFormator = (cellContent, row, rowIndex) => (
  <>
    {row?.country?.name && (
      <span>{row?.country?.name}</span>
    )}
    {row?.country?.length > 0 && (
      <ul style={{listStyleType:"none", display:"contents"}}>
        {row?.country?.map((e) => {
          return e?.name && <li key={e.name}>{e?.name}</li>;
        })}
      </ul>
    )}
  </>
);
